export const SENDGRID_REPORT_ENTRIES_CREATE = 'SENDGRID_REPORT_ENTRIES_CREATE'
export const SENDGRID_REPORT_ENTRIES_SUCCESS = 'SENDGRID_REPORT_ENTRIES_SUCCESS'
export const SENDGRID_REPORT_ENTRIES_ERROR = 'SENDGRID_REPORT_ENTRIES_ERROR'
export const SENDGRID_REPORT_ENTRIES_SET = 'SENDGRID_REPORT_ENTRIES_SET'

export const SENDGRID_REPORT_UPDATE_REQUEST = 'SENDGRID_REPORT_UPDATE_REQUEST'
export const SENDGRID_REPORT_UPDATE_SUCCESS = 'SENDGRID_REPORT_UPDATE_SUCCESS'
export const SENDGRID_REPORT_UPDATE_ERROR = 'SENDGRID_REPORT_UPDATE_ERROR'

export const SENDGRID_REPORT_DELETE_REQUEST = 'SENDGRID_REPORT_DELETE_REQUEST'
export const SENDGRID_REPORT_DELETE_SUCCESS = 'SENDGRID_REPORT_DELETE_SUCCESS'
export const SENDGRID_REPORT_DELETE_ERROR = 'SENDGRID_REPORT_DELETE_ERROR'

export const SENDGRID_REPORT_FETCH_SUCCESS = 'SENDGRID_REPORT_FETCH_SUCCESS'
export const SENDGRID_REPORT_FETCH_ERROR = 'SENDGRID_REPORT_FETCH_ERROR'
export const SENDGRID_REPORT_PREFERENCES_FETCH = 'SENDGRID_REPORT_PREFERENCES_FETCH'

export const SENDGRID_REPORT_RUNNOW_CREATE = 'SENDGRID_REPORT_RUNNOW_CREATE'
export const SENDGRID_REPORT_RUNNOW_SUCCESS = 'SENDGRID_REPORT_RUNNOW_SUCCESS'



// WEBPACK FOOTER //
// ./src/store/modules/reports/sendgrid-reports.type.js